export const localStorageKeys = {
  STORED_PATH: 'accuraiser-main-stored-path'
}
